import { Theme } from '@mui/material';
import { Dayjs } from 'dayjs';

// Shared by the Checkpoints and Quick Scan activity log grids

export const DEFAULT_PAGE = 0;
export const DEFAULT_PAGE_SIZE = 10;

export const utcFromDayjs = (dt: Dayjs | null): string => {
  return dt ? dt.toDate().toISOString().slice(0, 19) : '';
};

export const activityGridSx = (theme: Theme) => ({
  height: '100%',
  '& .MuiTablePagination-root': {
    marginRight: '100px',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: '500'
  },
  '& .MuiDataGrid-toolbarContainer': {
    backgroundColor: '#E3F2FD'
  },
  '& .MuiDataGrid-row': {
    cursor: 'pointer'
  },
  '& .selected-clearance-row': {
    backgroundColor: theme.palette.blueGrey[50],
  },
  '& .selected-clearance-row:hover': {
    backgroundColor: theme.palette.blueGrey[50],
  },
});
